/*
 * Search page API fallback.
 *
 * When the native search returns no products, this element queries the search
 * API for products the default engine missed, resolves them to Shopify product
 * cards (via an `id:` search), and renders them in place of the "no results"
 * message. On an empty API response the original message is restored.
 */
if (!customElements.get('search-api-fallback')) {
  customElements.define('search-api-fallback', class SearchApiFallback extends HTMLElement {
    connectedCallback() {
      this.term = this.dataset.term || '';
      this.country = this.dataset.country || '';
      this.sectionId = this.dataset.sectionId || '';
      this.resultsContainer = this.querySelector('.template-search__api-results');
      this.loader = this.querySelector('.template-search__api-loading');
      const template = this.closest('.template-search');
      this.noResults = template ? template.querySelector('.template-search__no-results') : null;

      if (!this.term || !this.country || !this.sectionId) {
        this.restore();
        return;
      }

      this.run();
    }

    run() {
      this.showLoading();

      fetch(`https://api-ott.manta.link/api/search?q=${encodeURIComponent(this.term)}&country=${encodeURIComponent(this.country)}&limit=30`, {
        headers: { 'Accept': 'application/json' }
      })
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => {
          const ids = data && data.success && Array.isArray(data.results)
            ? data.results.map((item) => item.product_id).filter(Boolean)
            : [];
          if (!ids.length) return null;
          return this.fetchProducts(ids);
        })
        .then((grid) => {
          if (grid) this.renderProducts(grid);
          else this.restore();
        })
        .catch(() => this.restore());
    }

    // Resolve API product IDs to rendered product cards through Shopify's search
    // (an `id:` query matches products even when the text query cannot).
    fetchProducts(ids) {
      const idsQuery = ids.map((id) => `id:${id}`).join(' OR ');
      const url = `${routes.search_url}?section_id=${encodeURIComponent(this.sectionId)}&q=${encodeURIComponent(idsQuery)}&type=product`;

      return fetch(url)
        .then((response) => (response.ok ? response.text() : ''))
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          return doc.querySelector('ul.product-grid');
        });
    }

    renderProducts(grid) {
      if (!grid || !this.resultsContainer) {
        this.restore();
        return;
      }
      HTMLUpdateUtility.setInnerHTML(this.resultsContainer, grid.outerHTML);
      this.hideLoading();
    }

    restore() {
      this.hideLoading();
      // Reveal the "no results" message (hidden by CSS while the API was checked).
      if (this.noResults) this.noResults.classList.remove('template-search__no-results');
    }

    showLoading() {
      if (this.loader) this.loader.classList.remove('hidden');
    }

    hideLoading() {
      if (this.loader) this.loader.classList.add('hidden');
    }
  });
}
